import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import reportWebVitals from './reportWebVitals';

const preloadImage = new Image();
preloadImage.src = process.env.PUBLIC_URL + '/background.jpg';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();

// Service worker registration disabled to fix build errors and remove PWA support.
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/service-worker.js').then(
//       registration => {
//         console.log('ServiceWorker registration successful:', registration);
//       },
//       err => {
//         console.log('ServiceWorker registration failed:', err);
//       }
//     );
//   });
// }

